<template>
  <div>
    <div class="ibox-content text-center" v-if="finished || loadingMore">
      <template v-if="loadingMore">
        <i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw text-muted"></i>
        <span class="sr-only">Loading...</span>
      </template>
      <template v-if="finished">
        <slot name="finished">No More Results</slot>
      </template>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import inView from 'in-view'
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        loadingMore: false,
        finished: false
      }
    },

    props: {
      offset: {
        type: Number,
        default: 50
      },
      reachedBottom: {
        type: Function,
        required: true
      },
      filters: {
        type: Object,
        default () {
          return {}
        }
      }
    },

    computed: mapState('app', ['loading']),

    watch: {
      /**
       * Watch the application loading property. We need this initial check
       * so we can determine if we should execute the load more on an
       * initial page load as we may not have enough results to fill
       * up the page.
       *
       * @return void
       */
      loading () {
        if (inView.is(this.$el)) {
          this.execute()
        }
      }
    },

    created () {
      this.$on('reset', () => {
        this.loadingMore = false
        this.finished = false

        if (inView.is(this.$el)) {
          this.execute()
        }
      })
    },

    /**
     * On mounted we will setup our execution callback. This will be bound
     * to the window scroll event.
     *
     * Note: This may have performance issues, potentially do the inView
     * inside of a setTimeout so we only check if the element is in view
     * after a given timeout, perhaps 50ms.
     *
     * @return {[type]}
     */
    mounted () {
      const executeIfInView = () => {
        if (inView.is(this.$el)) {
          this.execute()
        }
      }

      $(window).on('scroll.lazy', executeIfInView)
    },

    /**
     * Before destroy we remove the lazy scrolling binding.
     *
     * This prevents bindings from stacking through multiple page loads.
     *
     * @return void
     */
    beforeDestroy () {
      $(window).off('scroll.lazy')
    },

    methods: {
      execute () {
        if (this.loadingMore || this.finished) {
          return
        }

        this.loadingMore = true

        const noLongerLoading = () => (this.loadingMore = false)
        const noMoreResults = () => {
          this.finished = true
          this.loadingMore = false
        }

        this.reachedBottom(this.filters).then(noLongerLoading).catch(noMoreResults)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LazyLoading.vue?bf29ce74